<script setup>
import {computed, ref} from "vue";

const props = defineProps({
    content: {
        type: Object,
        required: true,
    },
})

const title = computed(() => props.content.title);
const body = computed(() => props.content.body);
const preview = computed(() => props.content.preview);

const collapsed = ref(true)

const collapseExpand = () => {
    collapsed.value = !collapsed.value
}

</script>
<template>
    <div
        class="overflow-hidden"
        :class="'text-' + props.content.alignment"
    >
        <h3 class="cursor-pointer hover:opacity-80 transition-opacity" @click="collapseExpand">
            {{ title }}
        </h3>
        <hr class="mt-2 mb-2">
        <div>
            <div v-if="!collapsed" v-html="body"></div>
            <div v-if="collapsed" v-html="preview"></div>
        </div>
        <p class="flex justify-end">
            <span v-if="!collapsed" class="cursor-pointer text-xs" @click="collapseExpand">{{ _mft('shared:expand.showLess') }}</span>
            <span v-if="collapsed" class="cursor-pointer text-xs read-more" @click="collapseExpand">{{ _mft('shared:expand.showMore') }}</span>
        </p>
    </div>
</template>
